import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { images } from "../assets/images";
import { BackgroundMedia } from "./BackgroundMedia";

export function IntroSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });

  return (
    <section
      ref={ref}
      className="relative h-screen w-full flex items-center justify-center overflow-hidden"
    >
      {/* Background Image - 水彩风格的咖啡与白鸽 */}
      <motion.div
        initial={{ scale: 1.05, opacity: 0 }}
        animate={isInView ? { scale: 1, opacity: 1 } : { scale: 1.05, opacity: 0 }}
        transition={{ duration: 2, ease: "easeOut" }}
        className="absolute inset-0"
      >
        <BackgroundMedia
          videoSrc={images.intro}
          imageSrc={images.introImage}
          className="w-full h-full object-cover"
        />
        {/* 轻微遮罩，保持水彩画的美感 */}
        <div className="absolute inset-0 bg-black/20" />
      </motion.div>

      {/* Content - 优雅的标语 */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
        transition={{ duration: 1.2, delay: 0.5, ease: [0.22, 1, 0.36, 1] }}
        className="relative z-10 text-center px-6 flex flex-col justify-between h-full pt-24 pb-32"
      >
        {/* 顶部文字 */}
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 1, delay: 0.8, ease: "easeOut" }}
          className="text-white text-xl md:text-3xl lg:text-4xl tracking-wide"
          style={{
            textShadow: "0 4px 30px rgba(0,0,0,0.3), 0 0 60px rgba(255,255,255,0.1)"
          }}
        >
          用您的一杯咖啡
          <br />
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 1, delay: 1.1, ease: "easeOut" }}
            className="inline-block mt-4"
          >
            拯救战争儿童
          </motion.span>
        </motion.h1>

        {/* 空白区域，让咖啡图片可见 */}
        <div className="flex-1" />

        {/* 向下滚动提示 */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : { opacity: 0 }}
          transition={{ duration: 1, delay: 2 }}
          className="absolute bottom-12 left-1/2 -translate-x-1/2"
        >
          <motion.div
            animate={{
              y: [0, 12, 0],
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              ease: "easeInOut",
            }}
            className="w-8 h-12 border-2 border-white/60 rounded-full flex items-start justify-center p-2"
          >
            <motion.div
              animate={{
                y: [0, 16, 0],
              }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "easeInOut",
              }}
              className="w-1.5 h-3 bg-white/80 rounded-full"
            />
          </motion.div>
        </motion.div>
      </motion.div>
    </section>
  );
}

